
const LoaderCircle = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" stroke={color ? color : '#000'}
            height="32" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-loader-circle"><path d="M21 12a9 9 0 1 1-6.219-8.56" /></svg>
    )
}

export default LoaderCircle;